import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessCitationView } from "app/models/mainMenu/mainMenu";

import { ComplaintService } from "app/services/complaint/complaint.service";


@Component({
  selector: 'addCitations',
  styleUrls: ['./addCitations.component.scss'],
  templateUrl: './addCitations.component.html'
})

export class AddCitationsComponent implements OnInit {

  currentCitation: IBusinessCitationView = {} as IBusinessCitationView;
  businessId: number = 0;
  savedCitation: boolean = false;
  flagReasonNotIssued: string = '';
  hearingRequested: string = '';
  finalOrderIssued: string = '';
  civilPenalty: string = '';
  settlementAgreement: string = '';
  complaintId: number = 0;

  ids: boolean = false;

  citation: IBusinessCitationView = {
    id: 0,
    requiredImplementationDate: '',
    requiredVisitDate: '',
    actualCompletionDate: '',
    violationNotes: '',
    correctionRequiredNotes: '',
    remediationResult: '',
    followupDate: '',
    followupConducted: 0,
    followupDateConducted: 0,
    comments: '',
    allowEditing: false,
    businessId: 0,
    complaintId: 0,
    canEdit: false,
    county: '',
    countyCopyDate: '',
    citationIssuedDate: '',
    fineReceivedDate: '',
    dhsReviewDate: '',
    dojReviewDate: '',
    notIssuedReason: '',
    visitDate: '',
    notes: '',
    finalOrderDate: '',
    penaltyAmt: '',
    settleAgree: '',
    finalOrderReason: '',
    saAmt: '',
    saAbeyance: '',
    saSigned: '',
    saUntil: '',
    saPaid: '',
    citationWarranted: false,
    hearingRequested: false,
    hearingReason: '',
    hearingDate: '',
    finalOrderIssued: false,
    civilPenatly: false,
    settlementAgreement: false,
    saRequiredAmt: '',
    complaintStatus: '',
    siteVisitDate: '',
    remediationDueDate: '',
    remediationFollowUpDate: '',
    complaintDate: '',
    businessName: '',
    address: '',
    city: '',
    zipCode: '',
    lastUpdatedBy: '',
    lastUpdatedDate: new Date(),
    businessFollowupSiteVisitId: 0,
    annualExemptInspectionStatusId: 0,
    annualExemptInspectionStatus: '',
  };

  form = new UntypedFormGroup({
    countyCopyDate: new UntypedFormControl(''),
    dhsReviewDate: new UntypedFormControl(''),
    dojReviewDate: new UntypedFormControl(''),
    citationWarranted: new UntypedFormControl(''),

    citationIssuedDate: new UntypedFormControl(''),
    penaltyAmt: new UntypedFormControl(''),
    hearingRequested: new UntypedFormControl(''),
    hearingDate: new UntypedFormControl(''),
    hearingReason: new UntypedFormControl(''),
    notIssuedReason: new UntypedFormControl(''),

    finalOrderIssued: new UntypedFormControl(''),
    finalOrderDate: new UntypedFormControl(''),
    finalOrderReason: new UntypedFormControl(''),
    civilPenatly: new UntypedFormControl(''),
    fineReceivedDate: new UntypedFormControl(''),

    settlementAgreement: new UntypedFormControl(''),
    saAmt: new UntypedFormControl(''),
    saRequiredAmt: new UntypedFormControl(''),
    saAbeyance: new UntypedFormControl(''),
    saSigned: new UntypedFormControl(''),
    saUntil: new UntypedFormControl(''),
    saPaid: new UntypedFormControl(''),
  });

  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AddCitationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.modalCitation != null && this.data.modalCitation != undefined) {
      this.citation = this.data.modalCitation;
      this.setForm(this.citation);
      this.setFlags();
      this.complaintId = this.citation.complaintId
    }
    else{
      this.complaintId = this.data.complaintId;
    }
    this.businessId = this.data.businessId;
  }

  ngOnInit(): void {
    this.savedCitation = false;
    this.ids = this.citation.id > 0 ? true : false;
  }

  save() {
    this.setData();

    this.complaintService.saveCitation(this.businessId, this.citation).subscribe({
      next: response => {
        this.sharedService.toastr.success("Saved");
        this.savedCitation = true;
        this.return();
      },
      error: e => {
        this.sharedService.toastr.error("Could not save Citation Info");
      },
    });
  }

  return(): void {
    let returnData = this.savedCitation ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

  warrantedFlag(flag: string) {
    this.flagReasonNotIssued = flag;
  }

  hearingRequestedFlag(flag: string) {
    this.hearingRequested = flag;
  }

  finalOrderIssuedFlag(flag: string) {
    this.finalOrderIssued = flag;
  }

  civilPenaltyFlag(flag: string) {
    this.civilPenalty = flag;
  }

  settlementAgreementFlag(flag: string) {
    this.settlementAgreement = flag;
  }

  setForm(data: IBusinessCitationView) {
    this.form.patchValue({
      countyCopyDate: data.countyCopyDate != '' ? new Date(data.countyCopyDate): '',
      dhsReviewDate: data.dhsReviewDate != '' ? new Date(data.dhsReviewDate): '',
      dojReviewDate: data.dojReviewDate != '' ? new Date(data.dojReviewDate): '',
      citationWarranted: data.citationWarranted? 'Yes' : 'No',

      citationIssuedDate: data.citationIssuedDate != '' ? new Date(data.citationIssuedDate): '',
      penaltyAmt: data.penaltyAmt,
      hearingRequested: data.hearingRequested? 'Yes' : 'No',
      hearingDate: data.hearingDate != '' ? new Date(data.hearingDate): '',
      hearingReason: data.hearingReason,
      notIssuedReason: data.notIssuedReason,

      finalOrderIssued: data.finalOrderIssued? 'Yes' : 'No',
      finalOrderDate: data.finalOrderDate != '' ? new Date(data.finalOrderDate): '',
      finalOrderReason: data.finalOrderReason,
      civilPenatly: data.civilPenatly? 'Yes' : 'No',
      fineReceivedDate: data.fineReceivedDate != '' ? new Date(data.fineReceivedDate): '',

      settlementAgreement: data.settlementAgreement? 'Yes' : 'No',
      saAmt: data.saAmt,
      saRequiredAmt: data.saRequiredAmt,
      saAbeyance: data.saAbeyance,
      saSigned: data.saSigned != '' ? new Date(data.saSigned): '',
      saUntil: data.saUntil != '' ? new Date(data.saUntil): '',
      saPaid: data.saPaid != '' ? new Date(data.saPaid): '',
    });
  }

  setData() {
    this.citation.countyCopyDate = this.datePipe.transform(this.form.controls['countyCopyDate'].value, 'MM/dd/yyyy');
    this.citation.citationIssuedDate = this.datePipe.transform(this.form.controls['citationIssuedDate'].value, 'MM/dd/yyyy');
    this.citation.fineReceivedDate = this.datePipe.transform(this.form.controls['fineReceivedDate'].value, 'MM/dd/yyyy');
    this.citation.dhsReviewDate = this.datePipe.transform(this.form.controls['dhsReviewDate'].value, 'MM/dd/yyyy');
    this.citation.dojReviewDate = this.datePipe.transform(this.form.controls['dojReviewDate'].value, 'MM/dd/yyyy');
    this.citation.notIssuedReason = this.form.controls['notIssuedReason'].value;
    this.citation.finalOrderDate = this.datePipe.transform(this.form.controls['finalOrderDate'].value, 'MM/dd/yyyy');
    this.citation.penaltyAmt = this.form.controls['penaltyAmt'].value;
    this.citation.finalOrderReason = this.form.controls['finalOrderReason'].value;
    this.citation.saAmt = this.form.controls['saAmt'].value;
    this.citation.saAbeyance = this.form.controls['saAbeyance'].value;
    this.citation.saSigned = this.form.controls['saSigned'].value;
    this.citation.saUntil = this.form.controls['saUntil'].value;
    this.citation.saPaid = this.form.controls['saPaid'].value;
    this.citation.citationWarranted = this.form.controls['citationWarranted'].value == 'Yes' ? true : false;
    this.citation.hearingRequested = this.form.controls['hearingRequested'].value == 'Yes' ? true : false;
    this.citation.hearingReason = this.form.controls['hearingReason'].value;
    this.citation.hearingDate = this.datePipe.transform(this.form.controls['hearingDate'].value, 'MM/dd/yyyy');
    this.citation.finalOrderIssued = this.form.controls['finalOrderIssued'].value == 'Yes' ? true : false;
    this.citation.civilPenatly = this.form.controls['civilPenatly'].value == 'Yes' ? true : false;
    this.citation.settlementAgreement = this.form.controls['settlementAgreement'].value == 'Yes' ? true : false;
    this.citation.saRequiredAmt = this.form.controls['saRequiredAmt'].value;
    this.citation.complaintId = this.complaintId;
  }

  setFlags(){
    this.flagReasonNotIssued = this.citation.citationWarranted ? 'Yes' : 'No';
    this.hearingRequested = this.citation.hearingRequested ? 'Yes' : 'No';
    this.finalOrderIssued = this.citation.finalOrderIssued ? 'Yes' : 'No';
    this.civilPenalty = this.citation.civilPenatly ? 'Yes' : 'No';
    this.settlementAgreement = this.citation.settlementAgreement ? 'Yes' : 'No';
  }

}